import { call, put, race, take, throttle } from "redux-saga/effects"
import config from '../../config.json'
import actionTypes from "../../actions/actionTypes"

function* getCheckAction () {
    const checkActions = yield ['@@router/LOCATION_CHANGE']

    const notCheck = yield [
        actionTypes.AUTH_CHECK_REQUEST,
        actionTypes.AUTH_CHECK_SUCCESS,
        actionTypes.AUTH_CHECK_ERROR,
        actionTypes.AUTH_FLOW_LOGIN_REQUEST_SESSION,
        actionTypes.AUTH_FLOW_LOGIN_REQUEST_FORCE_SESSION,
        actionTypes.AUTH_FLOW_LOGIN_REQUEST_BYPASS,
        actionTypes.AUTH_FLOW_LOGIN_REQUEST_FORCE_BYPASS,
        actionTypes.AUTH_FLOW_LOGOUT_REQUEST_CLIENT,
        actionTypes.AUTH_FLOW_LOGOUT_REQUEST_WP,
        actionTypes.AUTH_FLOW_SUCCESS,
        actionTypes.AUTH_FLOW_ERROR,
        actionTypes.AUTH_SET_SESSION_DATA,
        actionTypes.AUTH_SET_SESSION_DATA_ALIVE,
        actionTypes.AUTH_SET_CAPS_DATA,
        actionTypes.AUTH_CLEAR_DATA,
        actionTypes.CLEAR_ALL_DATA
    ]

    yield Object.values(actionTypes).map(action => {
        if(!notCheck.includes(action)) {
            checkActions.push(action)
        }
    })

    return yield checkActions
}


function* checkRequest(action) {
    try {
        if(
            !action || 
            '@@router/LOCATION_CHANGE' !== action.type || 
            config.routes.login.path !== action.payload.location.pathname
        ) {
            yield put({
                type: actionTypes.AUTH_CHECK_REQUEST,
                payload: {
                    initLoad: false
                }
            })
        }
    } catch(e) {
        yield put({
            type: actionTypes.AUTH_FLOW_LOGOUT_REQUEST_CLIENT
        })
    }
}


function* throttleCheck() {
    const checkActions = yield call(getCheckAction)

    yield call(checkRequest, false)
    yield throttle(6000, checkActions, checkRequest)
}


function* watchActivitySaga () {
    while (true) {
        yield take([actionTypes.LOAD_ALL_DATA_SUCCESS, actionTypes.LOAD_ALL_DATA_ERROR])
        yield race({
            task: call(throttleCheck),
            cancel: take([
                actionTypes.LOAD_ALL_DATA_REQUEST,
                actionTypes.AUTH_FLOW_LOGOUT_REQUEST_CLIENT,
                actionTypes.AUTH_FLOW_LOGOUT_REQUEST_WP
            ])
        })
    }
}

export default watchActivitySaga